import { DBDatasourceMethods } from '../types/DBSource';
import { IDataSourceTypes, TplTypes } from '../types/ICollection';
export function tryStringify(obj) {
    try {
        return JSON.stringify(obj);
    }
    catch {
        return obj;
    }
}
export function getGogoType(type) {
    return [IDataSourceTypes.HTTP, IDataSourceTypes.CODE].includes(type) ? 'api' : 'db';
}
export function checkIsMultiHTTPCollection(collection) {
    return collection.type === IDataSourceTypes.HTTP && collection.tplType === TplTypes.Universal;
}
export function isDBLikeDataSource(collection) {
    return [
        IDataSourceTypes.DB,
        IDataSourceTypes.ER,
        IDataSourceTypes.WUJI_1_0,
    ].includes(collection.type);
}
export const DB_METHODS = [
    DBDatasourceMethods.list,
    DBDatasourceMethods.count,
    DBDatasourceMethods.create,
    DBDatasourceMethods.update,
    DBDatasourceMethods.delete,
    DBDatasourceMethods.get,
];
export function checkIsDBMethodName(methodName) {
    return DB_METHODS.includes(methodName);
}
